/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'
import { ToRial } from '../../services/toRial'

export default function index(data) {
  const [category, setCategory] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCategory(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>شماره سفارش</th>
            <th>سفارش دهنده</th>
            <th>جمع</th>
            <th>تاریخ خرید</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {category ? category.map(item => (
              <tr key={item._id}>
                <td>{item.orderNumber}</td>
                <td>{item.user[0].name} - {item.user[0].phoneNumber}</td>
                <td>{ToRial(String(item.total))} تومان</td>
                <td>{item.createdAt} </td>
                <td>{item.payStatus ? (
                  <span className='success'>پرداخت شده</span>
                ) : (
                  <sapn className='failed'>پرداخت نشده</sapn>
                )}</td>
                <td>
                  <button onClick={() => navigate(`/order/${item._id}`)}>مشاهده</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
